import EntityOverviewCard from "../UI/EntityOverviewCard";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import transparentLogo from "../../transparent-logo.png";

const Img = styled("img")({
  display: "block",
  maxWidth: "80px",
  maxHeight: "80px",
  objectFit: "contain",
});

const CompetitionOverview = ({ competition }) => (
  <EntityOverviewCard
    testId="competitionOverview"
    image={
      <Box>
        <Img
          alt={competition.name}
          src="/static/images/url.jpg"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = transparentLogo;
          }}
        />
      </Box>
    }
    fields={[
      { label: "Name", value: competition.name },
      { label: "Owner", value: competition.user.username },
      { label: "Description", value: competition.description },
      { label: "URL", value: competition.url },
    ]}
  />
);

export default CompetitionOverview;
